export const transactionConstants = {
  TRANSTATION_LIST: "TRANSTATION_LIST"
};
